import { action } from 'nanostores'
import {
  $allowedChangesForWeeks,
  $campaignWeeks,
  $mealSwaps,
  $promises,
  $skippedWeeks,
  $subscription,
  $subscriptionWeeks,
  $subscriptionWeeksMenus,
} from './stores'
import dayjs from '@/utilities/dayjs-config'

export const setSubscription = action(
  $subscription,
  'setSubscription',
  (store, { subscription }) => {
    store.set(subscription)
  },
)

export const setSubscriptionWeek = action(
  $subscriptionWeeks,
  'setSubscriptionWeek',
  (store, { week, subscriptionWeek }) => {
    const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')

    store.setKey(weekString, subscriptionWeek)
  },
)

export const setSubscriptionWeekMenu = action(
  $subscriptionWeeksMenus,
  'setSubscriptionWeekMenu',
  (store, { week, menu }) => {
    const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')

    store.setKey(weekString, menu)
  },
)

export const setCampaignWeek = action(
  $campaignWeeks,
  'setCampaignWeek',
  (store, { week, campaignWeek }) => {
    const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')

    store.setKey(weekString, campaignWeek)
  },
)

export const setWeekMealSwaps = action(
  $mealSwaps,
  'setWeekMealSwaps',
  (store, { week, mealSwaps }) => {
    const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')

    store.setKey(weekString, mealSwaps)
  },
)

export const setSkippedWeeks = action(
  $skippedWeeks,
  'setSkippedWeeks',
  (store, { skippedWeeks }) => {
    store.set(skippedWeeks)
  },
)

export const setAllowedChangesForWeek = action(
  $allowedChangesForWeeks,
  'setAllowedChangesForWeek',
  (store, { week, allowedChanges }) => {
    const weekString = dayjs(week).startOf('week').format('YYYY-MM-DD')

    store.setKey(weekString, allowedChanges)
  },
)

export const clearSubscriptionWeeks = action(
  $subscriptionWeeks,
  'clearSubscriptionWeeks',
  (store) => {
    store.set({})
  },
)

export const clearSubscriptionWeeksMenus = action(
  $subscriptionWeeksMenus,
  'clearSubscriptionWeeksMenus',
  (store) => {
    store.set({})
  },
)

export const clearCampaignWeeks = action(
  $campaignWeeks,
  'clearCampaignWeeks',
  (store) => {
    store.set({})
  },
)

export const clearMealSwaps = action($mealSwaps, 'clearMealSwaps', (store) => {
  store.set({})
})

export const clearSkippedWeeks = action(
  $skippedWeeks,
  'clearSkippedWeeks',
  (store) => {
    store.set([])
  },
)

export const setPromise = action(
  $promises,
  'setPromise',
  (store, { promiseKey, promise }) => {
    store.setKey(promiseKey, promise)
  },
)
export const clearPromises = action($promises, 'clearPromises', (store) => {
  store.set({})
})
